import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "trash",
  "use": "trash-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"trash\"><g fill-rule=\"evenodd\"><path d=\"M5 6h10v11H5z\" opacity=\".09\" /><path d=\"M5 5h10v1H5z\" opacity=\".08\" /><path d=\"M5 16h10v1H5z\" opacity=\".15\" /><path d=\"M6 17c-.6 0-1-.48-1-1.2V5h10v10.8c0 .72-.4 1.2-1 1.2H6ZM8.5 3h3c.3 0 .5.2.5.5V4H8v-.5c0-.3.2-.5.5-.5ZM13 3c0-.6-.4-1-1-1H8c-.6 0-1 .4-1 1v1H4c-.6 0-1 .4-1 1h1v11c0 1 1 2 2 2h8c1 0 2-1 2-2V5h1c0-.6-.4-1-1-1h-3V3Z\" /><path d=\"M8 8h1v6H8zm3 0h1v6h-1z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol